export const PUSH_CURRENT_BOARD_CONNECTIONS = 'PUSH_CURRENT_BOARD_CONNECTIONS' as 'PUSH_CURRENT_BOARD_CONNECTIONS'
